module.exports = __webpack_public_path__ + "static/img/hn-news-1.aca882d3.png";